import { Fragment, memo } from 'react';

import { Columns3 } from 'lucide-react';
import { isEmpty, isNonNullish } from 'remeda';
import useSWR from 'swr';

import { CreateSlideButton } from './createSlideButton/CreateSlideButton';
import { DraggableSlideCards } from './draggableSlideCards/DraggableSlideCards';

import css from './MainScreenSlider.module.css';

import { mainScreenSettingsService } from 'v2/api/mainScreenSettingsService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';

export const MainScreenSlider = memo(() => {
  const { data, isLoading, mutate } = useSWR('getSlides', mainScreenSettingsService.getSlides);

  return (
    <Card>
      <div className={css.mainScreenSliderHeader}>
        <CardHeader title="All Presentation Slides" icon={Columns3} />

        <CreateSlideButton onSuccess={mutate} />
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        isNonNullish(data) && (
          <Fragment>
            {isEmpty(data) ? <EmptyPlaceholder /> : <DraggableSlideCards slides={data} onRevalidate={mutate} />}
          </Fragment>
        )
      )}
    </Card>
  );
});

MainScreenSlider.displayName = 'MainScreenSlider';
